import script from "./TopLeftPane.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopLeftPane.vue?vue&type=script&setup=true&lang=ts"

import "./TopLeftPane.vue?vue&type=style&index=0&id=5e126582&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e126582"]])

export default __exports__